// src/data/clients.js
// ➜ Ajoute/édite ici tes clients.
// - code : le mot de passe à donner au client (casse ignorée).
// - pcloudLink : le lien partagé pCloud (ou autre).
// - zip (optionnel) : lien de téléchargement ZIP.

const CLIENTS = [
  {
    id: "elodie_dazy",
    name: "Élodie Dazy",
    code: "DE_0823",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZBQJOZkCMuCqmrSw0Mus2wUai6AHNxvyVk",
    zip: "" // ou "https://…/elodie_dazy.zip"
  },
    {
    id: "clara_etienne",
    name: "Mariage Clara & Etienne",
    code: "CE_2607",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZjNFOZ9Fw8gHwNvwQ0m0oslJm5yS6vEOkV",
    zip: "" // ou "https://…/elodie_dazy.zip"
  },
  {
    id: "clara_etienne",
    name: "Portraits",
    code: "CE_1007",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZXVpOZXugXpjUqTz8xHB5miECi0FqOX95y",
    zip: "" // ou "https://…/elodie_dazy.zip"
  },
  {
    id: "amelie_&_richard",
    name: "Portraits",
    code: "AR_1107",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZKVpOZFzrbO3DFFupFrgEvekP3V5RSWjR7",
    zip: "" // ou "https://…/elodie_dazy.zip"
  },
  {
    id: "Laura_&_Mochine",
    name: "Portraits",
    code: "LM_2408",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZ4nbOZt7VT7hEvymjhy1oapFg1AkYXIbg7",
    zip: "" // ou "https://…/elodie_dazy.zip"
  },
    {
    id: "Alicia & Alain",
    name: "Pacs Alicia & Alain",
    code: "AA_1309",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZwDAOZiwFQLVG1foFbzS1RVGeITfYpCnhV",
    zip: "" 
  },
  {
    id: "Anniversaire_Martin",
    name: "Anniversaire de Martin",
    code: "MH_2709",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZW5eUZVSo6JQqGntQ8OxtkMCgxEXQKQFRV",
    zip: "" 
  },
  {
    id: "Emmanuelle_SCHMITT",
    name: "Portrait de famille - Anniversaire",
    code: "ES_2510",
    pcloudLink: "https://e.pcloud.link/publink/show?code=kZpB1IZOdlVfhTAelVfanPesImv77fh4OkX",
    zip: "" 
  },
  // {
  //   id: "sarah_marc",
  //   name: "Sarah & Marc",
  //   code: "SM_0625",
  //   pcloudLink: "https://…",
  //   zip: "https://…/sarah_marc.zip"
  // },
];

export default CLIENTS;